import { cn } from "@/lib/utils";

/** Styled tooltip for recharts. `formatter(value, name)` returns display string. */
export const ChartTooltip = ({ active, payload, label, formatter, labelFormatter, className }) => {
  if (!active || !payload || !payload.length) return null;
  const rows = payload.filter((p) => p.value !== null && p.value !== undefined && !p.hide);
  if (!rows.length) return null;
  return (
    <div className={cn("min-w-[160px] rounded-md border border-border bg-popover px-3 py-2.5 text-xs shadow-lift", className)}>
      <div className="mono mb-2 text-[10.5px] text-muted-foreground">{labelFormatter ? labelFormatter(label, payload) : label}</div>
      <div className="space-y-1.5">
        {rows.map((p) => (
          <div key={p.dataKey || p.name} className="flex items-center justify-between gap-5">
            <span className="inline-flex items-center gap-2 text-muted-foreground">
              <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ background: p.color || p.stroke || p.fill }} />
              {p.name}
            </span>
            <span className="metric font-medium text-foreground">{formatter ? formatter(p.value, p.name, p) : p.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
